import React from 'react';
import Component from 'components/Frame';
import {connect} from 'react-redux';
import {
	fetchWorks,
	fetchArtists
} from 'actions/WorksActions';
import {
	worksLoaded,
	artistsLoaded
} from 'selectors/worksSelectors';

export const mapStateToProps = (state) => {
	return {
		ready: state.ready,
		debugData: state.ui.debugData,
		worksLoaded: worksLoaded(state),
		artistsLoaded: artistsLoaded(state)
	};
}

export const mapDispatchToProps = (dispatch) => {
	return {
		fetchData: () => {
			dispatch(fetchArtists())
			.then(() => dispatch(fetchWorks()))
		}
	};
}

export const FrameContainer = connect(
	mapStateToProps,
	mapDispatchToProps
)(Component);
export default FrameContainer;